// import { url } from '@/config';
var request = window.axios;
export const getList = (params) => request({
  url: '/api/sophain-visual/map/list',
  method: 'get',
  params: params
});
export const getObj = (id) => request({
  url: '/api/sophain-visual/map/detail',
  method: 'get',
  params: {
    id
  }
});
export const addObj = (data) => request({
  url: '/api/sophain-visual/map/save',
  method: 'post',
  data: data
});
export const updateObj = (data) => request({
  url: '/api/sophain-visual/map/update',
  method: 'post',
  data: data
});
export const delObj = (id) => request({
  url: '/api/sophain-visual/map/remove',
  method: 'post',
  params: {
    ids: id
  }
});